export const isApiGatewayUrl = (url: string) => ['/gateway/api'].includes(url);
